<template>
  <div class="contact_form">
    <div class="form_area">
      <dl class="form_parts">
        <dt class="parts_ttl">お名前</dt>
        <dd class="parts_ele">{{data.name}}</dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl">フリガナ</dt>
        <dd class="parts_ele">{{data.ruby}}</dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl">電話番号</dt>
        <dd class="parts_ele">{{data.tel}}</dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl">メールアドレス</dt>
        <dd class="parts_ele">{{data.mail}}</dd>
      </dl>
      <dl class="form_parts">
        <dt class="parts_ttl">備考</dt>
        <dd class="parts_ele">{{data.comment}}</dd>
      </dl>
    </div>
    <div class="form_btn">
      <button class="btn" @click="thanks">送信する</button>
      <button class="btn" @click="back">戻る</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmTmp',
  props: ['data'],
  data () {
    return {
      msg: 'confirm'
    }
  },
  methods: {
    thanks () {
      // function内ではthisの参照ができないため変数保持
      // arrow　function の場合は不要（IE11対応）
      const $this = this;
      this.data.error = false;

      const wrapLoadingImg = this.generateLoading();

      // 送信先設定、テンプレート設定(globalから取得)
      this.data.fromMail = fromAddress;
      this.data.fromName = fromName;
      this.data.thanksTmp = thanksTmp;
      this.data.receiveTmp = receiveTmp;

      // 同一サーバー（same-origin）内にpost_mail.phpが存在しない場合は
      // modeをcorsに変更
      fetch('/post_mail.php', {
        method: 'POST',
        body: JSON.stringify(this.data),
        headers: { "Content-type" : "application/x-www-form-urlencoded" },
        mode: 'same-origin'
      }).then(function (response) {
        return response.text();
      }).then(function(text){
        let pagaName = '';
        if (text == "post mail") {
          pagaName = 'thanks';
        } else {
          pagaName = 'input';
          $this.data.error = true;
          // 不要データの削除
          delete $this.data.fromMail;
          delete $this.data.fromName;
          delete $this.data.thanksTmp;
          delete $this.data.receiveTmp;
        }
        $this.$emit('change-page', pagaName, $this.data);
      }).then(function(){
        wrapLoadingImg.remove();
      });
    },
    back () {
      this.$emit('change-page', 'input', this.data)
    },
    generateLoading () {
      // loading生成
      const key = this.$el.attributes[0].name;
      const wrapLoadingImg = document.createElement('div');
      wrapLoadingImg.classList.add('wrap_loading');
      const loadingImg =  document.createElement('div');
      loadingImg.classList.add("loading_img");
      // scoped css を効かせるために属性の付与
      wrapLoadingImg.setAttribute(key, '');
      loadingImg.setAttribute(key, '');
      wrapLoadingImg.append(loadingImg);
      this.$el.append(wrapLoadingImg);

      return wrapLoadingImg;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.contact_form {
  .form_parts {
    display: flex;
    @media (max-width: 768px) {
      display: block;
      margin-top: 20px;
    }
    .parts_ttl {
      width: 200px;
      @media (max-width: 768px) {
        width: 100%;
      }
    }
    .parts_ele {
      width: calc(100% - 200px);
      @media (max-width: 768px) {
        width: 100%;
        margin-top: 10px;
        margin-left: 0;
      }
    }
  }
  .form_btn {
    margin-top: 30px;
    text-align: center;
    .btn {
      appearance: none;
      min-width: 150px;
      padding: 10px 20px;
      border: none;
      border-radius: 5px;
      font-size: 18px;
      &:focus {
        outline: none;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.wrap_loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  .loading_img {
    position: fixed;
    top: 50%;
    left: 50%;
    display: block;
    width: 50px;
    height: 50px;
    margin-top: -25px;
    margin-left: -25px;
    border-radius: 50px;
    background: #bbb;
    animation: rolling 1s linear;
    animation-iteration-count: infinite;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 2px;
      display: block;
      width: 23px;
      height: 48px;
      border-left: 23px;
      border-radius: 0 0 0 23px;
      background-color: #fff;
    }
    &:after {
      content: '';
      position: absolute;
      top: 2px;
      left: 25px;
      display: block;
      width: 23px;
      height: 46px;
      border-right: 23px;
      border-radius: 0 23px 23px 0;
      background-color: #fff;
    }
  }
}
@keyframes rolling {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmTmp.vue